import i18n
	from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector
	from 'i18next-browser-languagedetector';
import translation_de
	from "./locales/de/translation.json"
import translation_en
	from "./locales/en/translation.json"

import Backend
	from 'i18next-http-backend';

const DETECTION_OPTIONS = {
	order: ['localStorage', 'navigator'],
	caches: ['localStorage']
};

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		detection: DETECTION_OPTIONS,
		defaultLocale: "de-DE",
		defaultLanguage: 'de',
		fallbackLng: 'de-DE',
		debug: true,
		resources: {
			'de-DE': translation_de,
			'de': translation_de,
			'en-US': translation_en,
			'en': translation_en
		},
		supportedLngs: [
			'de-DE',
			'de',
			'en-US',
			'en'
		],
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		react: {
			useSuspense: false
		}
	});

export default i18n;